export default __webpack_public_path__ + "static/media/HERO_XS.e4218365.png";